import React, { useEffect, useState } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { useSelector } from "react-redux";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function MultiSelect(props) {
  const incomeInfo = useSelector((state) => state.income.incomeInfo);
  const [memberName, setMemberName] = useState([]);
  const personalInfo = useSelector((state) => state.personal.personalInfo);

  const setRole = (role) => {
    if (role !== "") {
      if (["Mother", "Father", "Guardian"].includes(role)) {
        role = "My " + role;
      }
    }
    // console.log('role', role)
    return role;
  };
  const getList = () => {
    let list = [];
    if (props.type === "income") {
      incomeInfo.membersList.forEach((element) => {
        list = [...list, setRole(element.relationShipType)];
      });
    } else  if (props.type === "disability" && personalInfo?.disability)  {
      list = [...personalInfo?.disability];
    }
    // console.log('props.list', props.list)
    if (list?.length === 0) {
      list = props.list || [];
    }
    // props.getList(list)
    setMemberName([...list]);
  };
  const handleChange = (event) => {
    let {
      target: { value },
    } = event;

    if (value.includes("No-one")) {
      if (memberName.includes("No-one")) {
        value.splice(0, 1);
      } else {
        value = ["No-one"];
      }
      props.onChange([...value]);
      setMemberName([...value]);
    } else {
      let newValue = typeof value === "string" ? value.split(",") : value;
      props.onChange([...newValue]);

      setMemberName(
        // On autofill we get a stringified value.
        newValue
      );
      // console.log("event", value);
    }
  };
  useEffect(() => {
    getList();
  }, []);
  useEffect(() => {
    getList();
  }, [incomeInfo.membersList, personalInfo?.disability, props.list]);

  // console.log("memberName", memberName, personalInfo?.disability);
  return (
    <div className="multi-select-dropdown select-earning-members">
      <FormControl sx={{ m: 1, width: 300 }}>
        <InputLabel id="demo-multiple-checkbox-label">{props.title}</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={memberName}
          onChange={handleChange}
          input={<OutlinedInput label="Tag" />}
          renderValue={(selected) => selected.join(", ")}
          MenuProps={MenuProps}
        >
          {props.names?.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={memberName.indexOf(name) > -1} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

export default MultiSelect;
